<template>
  <div>
    <div class="home-header"></div>
    <div class="personal-title">
      <div class="personal-title-head">
        <div>
          <div style="font-size: 16px;margin-bottom: 10px">付款给</div>
          <div style="font-weight: bold;">{{hospitalName}}</div>
        </div>
        <van-image round :src="hospitalImage"
                   width="50" height="50"/>
      </div>
    </div>
    <div class="payment_details">
      <div class="payment_details_title">
        <div>费用总额</div>
        <div>{{ zhifxdResult.feeSumamt }} 元</div>
      </div>
      <div class="payment_details_body" style="margin-top: 20px">
        <div>医保基金支付</div>
        <div>{{ zhifxdResult.fundPay }} 元</div>
      </div>
      <div class="payment_details_body">
        <div>个人账户支付</div>
        <div>{{ zhifxdResult.psnAcctPay }} 元</div>
      </div>
      <div class="payment_details_body">
        <div>其他抵扣金额</div>
        <div>{{ zhifxdResult.othFeeAmt }} 元</div>
      </div>
      <div class="payment_details_body"
           style="color: #3b71e8; margin-top: 20px; font-size: 16px;font-weight: bold;">
        <div>现金支付</div>
        <div>{{ zhifxdResult.ownPayAmt }} 元</div>
      </div>
      <div @click="viewDetails" v-if="zhifxdResult.recipeInfo"
           style="width: 100%; font-size: 16px; display: flex;align-items: center; justify-content: center; margin-top: 20px; border-top: 2px dashed #eff0f4;    padding-top: 20px;">
        查看明细
      </div>
    </div>

    <div style="display: flex; justify-content: center; align-items: center; position: relative; top: -20px">
      <van-image :src="yycgImg" width="40" height="10"/>
      <span style="font-size: 16px; color: #666; margin-left: 12px;">医保移动支付</span>
    </div>
    <div class="medpay-footer">
      <div>
        <span style="color: #666; font-size: 16px">您还需支付：</span>
        <span style="color: #3b71e8; font-size: 20px;">￥{{ zhifxdResult.ownPayAmt }}</span>
      </div>
      <div style="padding-right: 35px;">
        <van-button color="#3b71e8" round @click="payNow">去支付</van-button>
      </div>
    </div>
    <van-popup v-model="show" closeable :style="{ height: '80%' }" round @close="show = false"
               position="bottom ">
      <div class="popup-header">
        <span>处方明细</span>
      </div>
      <div class="popup-body">
        <div class="popup-body-item" v-if="zhifxdResult.recipeInfo && zhifxdResult.recipeInfo.jzxx">
          <div class="popup-body-item-header">
            <div>就诊信息</div>
          </div>
          <div class="popup-body-item-body">
            <div class="popup-body-item-header-mx">
              <div>门诊类型</div>
              <div>{{ zhifxdResult.recipeInfo.jzxx.mzlx }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>门诊科室</div>
              <div>{{ zhifxdResult.recipeInfo.jzxx.ksmc }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>医生姓名</div>
              <div>{{ zhifxdResult.recipeInfo.jzxx.ysxm }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>处方时间</div>
              <div>{{ zhifxdResult.recipeInfo.jzxx.cfsj }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>费用总额</div>
              <div style="color: #3b71e8;font-weight: bold;">{{ zhifxdResult.recipeInfo.jzxx.fyze }} 元</div>
            </div>
          </div>
        </div>
        <div class="popup-body-item" v-if="zhifxdResult.recipeInfo && zhifxdResult.recipeInfo.zdxx">
          <div class="popup-body-item-header">
            <div>诊断信息</div>
          </div>
          <div class="popup-body-item-body">
            <div class="popup-body-item-header-mx">
              <div>诊断名称</div>
              <div>{{ zhifxdResult.recipeInfo.zdxx.zdmc }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>诊断编号</div>
              <div>{{ zhifxdResult.recipeInfo.zdxx.zdbm }}</div>
            </div>
          </div>
        </div>
        <div class="popup-body-item" v-if="zhifxdResult.recipeInfo && zhifxdResult.recipeInfo.tsxx">
          <div class="popup-body-item-header">
            <div>特殊信息</div>
          </div>
          <div class="popup-body-item-body">
            <div class="popup-body-item-header-mx">
              <div>病情名称</div>
              <div>{{ zhifxdResult.recipeInfo.tsxx.bqmc }}</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>病情编号</div>
              <div>{{ zhifxdResult.recipeInfo.tsxx.bqbh }}</div>
            </div>
          </div>
        </div>
        <div class="popup-body-item" v-if="zhifxdResult.recipeInfo && zhifxdResult.recipeInfo.jzxx">
          <div class="popup-body-item-header">
            <div>费用信息</div>
          </div>
          <div class="popup-body-item-body">
            <div v-for="item in zhifxdResult.recipeInfo.fyxx" :key="item.xmmc">
              <div class="popup-body-item-header-mx">
                <div style="line-height: 20px;">{{ item.xmmc }} * {{ item.sl }}<br/>{{ item.gg }}</div>
                <div style="font-size: 16px; color: #828488">{{ item.je }}元</div>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-body-item" v-if="zhifxdResult.recipeInfo && zhifxdResult.recipeInfo.qtdk">
          <div class="popup-body-item-header">
            <div>其他抵扣金额</div>
          </div>
          <div class="popup-body-item-body">
            <div class="popup-body-item-header-mx">
              <div>住院押金抵扣</div>
              <div>{{ zhifxdResult.recipeInfo.qtdk.zyyj }} 元</div>
            </div>
            <div class="popup-body-item-header-mx">
              <div>医院负担金额抵扣</div>
              <div>{{ zhifxdResult.recipeInfo.qtdk.yyfdje }} 元</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {wxMedGroupPay} from "@/api/card";
export default {
  data() {
    return {
      hospitalName: process.env.VUE_APP_HOSPITAL_NAME, // 医院名称
      hospitalImage: process.env.VUE_APP_HOSPITAL_IMAGE, // 医院图片
      yycgImg: require('@assets/medical-logo.png'),
      show: false,
      zhifxdResult: {
        recipeInfo: {
        }
      },
      wxPayData:{},
      yllb:null
    };
  },
  mounted() {
    this.yllb=this.$route.query.yllb
    this.zhifxdResult = this.$route.query.info.medPlaceOrderOutVO
    this.zhifxdResult.recipeInfo = JSON.parse(this.$route.query.info.medPlaceOrderOutVO.recipeInfo)
  },
  methods: {
    //查看明细
    viewDetails() {
      this.show = true;
    },
    //去支付
    payNow() {
      const url = process.env.VUE_APP_PAY_URL +"?orderNo="+this.$route.query.orderNo+'&yllb='+this.yllb+'&flag='+this.$route.query.flag;// 聚合支付回调地址
      wxMedGroupPay({orderNo: this.$route.query.orderNo,returnUrl:url,yllb: this.yllb}).then(res=>{
        if(res.success){
          //聚合支付成功之后回调页面
          window.location.href =  res.result.payUrl;
        }
      });
    }
  }
};
</script>

<style>
.home-header {
  height: 200px;
  width: 100%;
  position: absolute;
  overflow: hidden;
  border-radius: 0 0 45px 45px;
  background: #3b71e8;
}

.personal-title {
  width: 100%;
  position: relative;
  padding: 40px 30px 30px 30px;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
}

.personal-title-head {
  color: #ffffff;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.payment_details {
  margin: 20px;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px;
  position: relative;
  top: -20px;

}

.payment_details_title {
  font-weight: bold;
  font-size: 16px;
  color: #606266;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px dashed #eff0f4;
}


.payment_details_body {
  font-size: 16px;
  margin-top: 20px;
  color: #909399;
  display: flex;
  justify-content: space-between;
}

.medpay-footer {
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
}

.popup-header {
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 20px;
  font-weight: bold;
}

.popup-body {
  height: calc(80vh - 60px);
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.popup-body-item {
  border: 1px solid #e6e6e6;
  color: #606266;
  margin-bottom: 10px;
  border-radius: 10px;
}

.popup-body-item-body {
  padding: 10px;
  color: #606266;
  font-size: 14px;
  box-sizing: border-box;
  line-height: 30px;
  border-top: 1px solid #e6e6e6;
}

.popup-body-item-header {
  border-left: 5px solid #3b71e8;
  font-weight: bold;
  font-size: 16px;
  color: #606266;
  margin: 20px 20px 20px 0px;
  padding-left: 20px;
}

.popup-body-item-header-mx {
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
}

</style>
